//system
import { Injectable } from '@angular/core';
import { HttpService, HttpServiceConfig } from './common/http.service';

//services
import { LogService } from './common/log.service';

//models
import { ShortLink } from 'src/app/models/invite-code';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class ShortLinkService {

  constructor(private logService: LogService
    , private httpService: HttpService
    , private _environmentService: EnvironmentService
  ) { 
    const config: HttpServiceConfig = {
      baseUrl: `${this._environmentService.getFacilityConfig().facilityUrl}api/v${this._environmentService.getFacilityConfig().facilityApiVersion}`
    };
    this.httpService.configure(config);
  }

  async getShortLinkDetailsByCode(code: string): Promise<ShortLink> {
    return await this.httpService.getPromise<ShortLink>(`ShortLink/ByCode/${code}`);
  }
}
